import { MenuItem } from '@mui/material';
import { IWallet } from '@efex-services/client/types';
import { CURRENCY_ICON } from '@efex-components/common/Form/config';
import { WalletTypes } from '@constants/enums';
import { GroupHeader } from './GroupHeader';
import { useCurrencySelector } from '../../hooks/useCurrencySelector';

interface AccountsGroupProps {
  accounts: IWallet[];
  accountType: WalletTypes;
  groupTitle: string;
  tooltipTitle: string;
}

export const AccountsGroup = ({
  accounts,
  accountType,
  groupTitle,
  tooltipTitle,
}: AccountsGroupProps) => {
  const { translations } = useCurrencySelector();

  if (!accounts.length) return [];

  return [
    <GroupHeader
      key={`header-${accountType}`}
      title={groupTitle}
      tooltipTitle={tooltipTitle}
    />,
    ...accounts.map((wallet) => (
      <MenuItem key={wallet.uuid} value={wallet.uuid}>
        {CURRENCY_ICON[wallet.currency.name as keyof typeof CURRENCY_ICON]}
        {translations.getCurrencyName(wallet.currency.name)}
      </MenuItem>
    )),
  ];
};

export default AccountsGroup;
